import { render, staticRenderFns } from "./ViewMaximizedBulkClaimInvoicesDialog.vue?vue&type=template&id=4dc3fc04&scoped=true&lang=pug&"
import script from "./ViewMaximizedBulkClaimInvoicesDialog.vue?vue&type=script&lang=js&"
export * from "./ViewMaximizedBulkClaimInvoicesDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc3fc04",
  null
  
)

export default component.exports